module.exports = __webpack_public_path__ + "static/media/logo-mon-test-auditif-blanc.a91e6833.png";